module.exports = __webpack_public_path__ + "img/new_17.e3e01690.jpg";